module.exports = __webpack_public_path__ + "media/customerVideo2.1369c358.mp4";